import { type FormEvent, useState } from 'react';
import { useApi } from '@plataforma/web/api';
import { fechaCorta } from '../formato';
import type { Vehiculo } from '../paginas/tipos';

/** Baja lógica (registro por error o que no se compró): sale del inventario, no se borra. */
export function BajaVehiculo({ v, alCambiar }: { v: Vehiculo; alCambiar: () => void }) {
  const api = useApi();
  const [abierto, setAbierto] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const reactivar = async () => {
    try {
      await api('POST', `/inventory/vehiculos/${v.id}/reactivar`);
      alCambiar();
    } catch (err) {
      setError((err as Error).message);
    }
  };
  if (v.baja)
    return (
      <div className="error" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ flex: 1 }}>
          Dado de baja el {fechaCorta(v.baja.en)}: {v.baja.motivo}. No cuenta en el inventario.
        </span>
        <button className="boton" onClick={() => void reactivar()}>
          Reactivar
        </button>
        {error && <span>{error}</span>}
      </div>
    );
  if (!abierto)
    return (
      <button
        className="boton"
        style={{ alignSelf: 'flex-start' }}
        onClick={() => setAbierto(true)}
      >
        Dar de baja
      </button>
    );
  const enviar = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await api('POST', `/inventory/vehiculos/${v.id}/baja`, {
        motivo: new FormData(e.currentTarget).get('motivo'),
      });
      setAbierto(false);
      alCambiar();
    } catch (err) {
      setError((err as Error).message);
    }
  };
  return (
    <form
      className="seccion cuerpo formulario"
      onSubmit={(e) => void enviar(e)}
      style={{ flexBasis: '100%' }}
    >
      <label className="campo" style={{ gridColumn: '1 / -1' }}>
        <span>Motivo de la baja (queda en el historial; el vehículo se puede reactivar)</span>
        <input
          name="motivo"
          required
          minLength={5}
          maxLength={300}
          placeholder="Registrado por error / no se compró"
        />
      </label>
      {error && (
        <p className="error" style={{ gridColumn: '1 / -1' }}>
          {error}
        </p>
      )}
      <div className="acciones">
        <button type="button" className="boton" onClick={() => setAbierto(false)}>
          Cancelar
        </button>
        <button
          className="boton primario"
          style={{ background: 'var(--peligro)', borderColor: 'var(--peligro)' }}
        >
          Dar de baja
        </button>
      </div>
    </form>
  );
}
